import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { Instagram, Twitter, Facebook, ArrowUpRight, Mail, MapPin, Globe } from 'lucide-react';

const Footer = () => {
  const { isDarkMode } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-thriftBlack border-t border-zinc-100 dark:border-white/5 pt-20 pb-10 transition-colors duration-500">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-20">
          
          {/* Brand & Mission - 5 Columns */}
          <div className="md:col-span-5 space-y-8">
            <h2 className="text-4xl font-black italic tracking-tighter uppercase dark:text-white leading-none">
              WE <span className="bg-thriftBlack dark:bg-thriftSilver text-white dark:text-thriftBlack px-2">THRIFT</span>
            </h2>
            <p className="text-thriftGrey text-[11px] font-bold uppercase tracking-[0.2em] leading-relaxed max-w-sm">
              Curating rare archives and premium streetwear for the bold. 
              Our mission is to give high-end fashion a second life.
            </p>
            <div className="flex gap-4">
               <SocialIcon icon={<Instagram size={18}/>} />
               <SocialIcon icon={<Twitter size={18}/>} />
               <SocialIcon icon={<Facebook size={18}/>} />
            </div>
          </div>

          {/* Links - 7 Columns */}
          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {/* Navigation */}
            <FooterGroup title="Discover">
  <FooterLink to="/products" label="The Archive" />
  <FooterLink to="/category/hoodies" label="Hoodies" />
  <FooterLink to="/category/jackets" label="Outerwear" />
  {/* Ye raha tera About Us link */}
  <FooterLink to="/about-us" label="Our Story" /> 
</FooterGroup>

            {/* Support */}
            <FooterGroup title="Help">
              <FooterLink to="/profile" label="Track Order" />
              <FooterLink to="/shipping" label="Shipping" />
              <FooterLink to="/returns" label="Returns" />
              <FooterLink to="/contact" label="Contact" />
            </FooterGroup>

            {/* Legal */}
            <FooterGroup title="Legal">
              <FooterLink to="/privacy-policy" label="Privacy Policy" />
              <FooterLink to="/terms" label="Terms of Service" />
              <FooterLink to="/cookie-policy" label="Cookies" />
            </FooterGroup>
          </div>
        </div>

        {/* Bottom Strip */}
        <div className="pt-10 border-t border-zinc-100 dark:border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.3em] text-thriftGrey">
            <Globe size={12} /> GLOBAL ARCHIVE // BASED IN INDIA
          </div>
          
          <p className="text-[9px] font-black uppercase tracking-[0.4em] text-thriftGrey">
            © {currentYear} THE_THRIFT_VAULT. ALL RIGHTS RESERVED.
          </p>

          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="group text-[9px] font-black uppercase tracking-widest dark:text-white flex items-center gap-2"
          >
            Back to Top <ArrowUpRight size={12} className="group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
};

// Sub-components for cleaner code
const FooterGroup = ({ title, children }) => (
  <div className="space-y-6">
    <h4 className="text-[10px] font-black uppercase tracking-[0.4em] text-zinc-400 dark:text-zinc-600 italic">
      {title}
    </h4>
    <ul className="space-y-3">
      {children}
    </ul>
  </div>
);

const FooterLink = ({ to, label }) => (
  <li>
    <Link to={to} className="text-[10px] font-black uppercase tracking-widest text-thriftBlack dark:text-thriftSilver hover:text-thriftGrey dark:hover:text-zinc-500 transition-colors">
      {label}
    </Link>
  </li>
);

const SocialIcon = ({ icon }) => (
  <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-zinc-200 dark:border-zinc-800 text-thriftBlack dark:text-thriftSilver hover:bg-thriftBlack hover:text-white dark:hover:bg-thriftSilver dark:hover:text-thriftBlack transition-all">
    {icon}
  </a>
);

export default Footer;